import 'leaflet-draw';
import { Feature } from 'geojson';
import leaflet, { DrawEvents, DrawMap, LeafletEventHandlerFn, MarkerOptions } from 'leaflet';
import { inImageBounds } from '../../../../helpers/geometry/mapExtensions.helpers';
import { getSimplifiedGeoJSON } from '../../../../helpers/geometry/polygon.helpers';
import { MOUSE_BUTTON, MOUSE_EVENTS, MouseLeafletEvent } from '../../annotations.interface';
import { IDrawer } from './IDrawer';

export class DrawPoint extends leaflet.Draw.CircleMarker implements IDrawer {
  private readonly onDrawCreated: (geojson: Feature) => void;

  constructor(map: DrawMap, onDrawCreated: (geojson: Feature) => void, options?: MarkerOptions) {
    super(map, options);
    this.onDrawCreated = onDrawCreated;
  }

  disableMouseMarkerFocus(): void {
    this._mouseMarker = leaflet.marker(this._map.getCenter(), {
      icon: leaflet.divIcon({
        className: 'leaflet-mouse-marker',
        iconAnchor: [20, 20],
        iconSize: [40, 40],
      }),
      opacity: 0,
      zIndexOffset: this.options.zIndexOffset,
      keyboard: false,
    });
  }

  public addHandlers(): void {
    this._map.on(leaflet.Draw.Event.CREATED, this.handleDrawCreated as unknown as LeafletEventHandlerFn);
    this._map.on(MOUSE_EVENTS.MOUSE_UP, this.handleMouseUp);
  }

  public removeHandlers(): void {
    this._map.off(leaflet.Draw.Event.CREATED, this.handleDrawCreated as unknown as LeafletEventHandlerFn);
    this._map.off(MOUSE_EVENTS.MOUSE_UP, this.handleMouseUp);
  }

  handleDrawCreated = (e: DrawEvents.Created): void => {
    const simplifiedGeojson = getSimplifiedGeoJSON(e.layer);
    if (!simplifiedGeojson) {
      return;
    }

    this.onDrawCreated(simplifiedGeojson);
  };

  handleMouseUp = (e: MouseLeafletEvent): void => {
    if (e.originalEvent.button !== MOUSE_BUTTON.LEFT) {
      return;
    }
    if (this._marker && inImageBounds(this._marker.getLatLng(), this._map)) {
      this._fireCreatedEvent();

      this.disable();
      if (this.options.repeatMode) {
        this.enable();
      }
    }
  };

  _onClick(): void {}
  _onTouch(): void {}
}
